import { Button, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { FormInputItem } from "../../../../components/formInput";
import {
  BankOutlined,
  FieldNumberOutlined,
  UserOutlined,
  VerifiedOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { BANK_TYPE } from "../../../../lib/config";
import { CreateDataById, GetDataFromServer } from "../../../../lib/api";
import { USER_BANK_CREATE } from "../../../../lib/config";

export default function UserBankForm({ closeDrawer, detail }) {
  const { access_token, csrf_token, ui_size } = useSelector(
    (state) => state.user
  );
  const [loading, setLoading] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [selectedBankType, setSelectedBankType] = useState("");
  const [form] = Form.useForm();

  async function getDataList() {
    await GetDataFromServer(BANK_TYPE, access_token)
      .then(({ data: { data: res, total } }) => {
        setBankList(res);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList();
  }, []);

  async function submitHandler(values) {
    setLoading(true);
    CreateDataById(
      USER_BANK_CREATE,
      detail.id,
      values,
      access_token,
      csrf_token
    )
      .then(() => {
        toast.success("Created Bank Account Successfully");
        setLoading(false);
        closeDrawer(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message);
      });
  }

  function handleBankTypeChange(value) {
    setSelectedBankType(value);

    if (value.endsWith("PAY")) {
      form.setFieldsValue({ acc_number: "+95" });
    } else {
      form.setFieldsValue({ acc_number: "" });
    }
  }

  function handleAccNumberChange(e) {
    const input = e.target.value;
    const prefix = "+95 ";

    if (selectedBankType.endsWith("PAY")) {
      if (!input.startsWith(prefix)) {
        return prefix + input.replace(/^\+95\s*/, "").replace(/[^\d]/g, "");
      }

      if (input.length < prefix.length) {
        return prefix;
      }

      const rest = input.slice(prefix.length).replace(/[^\d]/g, "");
      return prefix + rest;
    }

    return input.replace(/[^\d]/g, "");
  }
  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 25, height: 25, marginRight: 8, borderRadius:"5px" }}
        />
        <span>{value.replace(/_/g, " ")}</span>
      </div>
    );
  }

  function validateAccountNumber(_, value) {
    if (selectedBankType.endsWith("PAY")) {
      if (!value.startsWith("+95 ")) {
        return Promise.reject(new Error("Account number must start with +95"));
      }
      
      
      const digitsAfterPrefix = value.replace("+95 ", "").trim();
      if (!digitsAfterPrefix || digitsAfterPrefix.length === 0) {
        return Promise.reject(new Error("Please enter phone number after +95"));
      }
      
    }
    
    return Promise.resolve();
  }
  return (
    <Form
      size={ui_size}
      form={form}
      onFinish={submitHandler}
      name="New Bank Account Form"
      layout="vertical"
    >
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Bank Type"
            name="bank_type"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={
                <span>
                  <BankOutlined style={{ marginRight: 8 }} />
                  Select Bank Type
                </span>
              }
              options={bankList.map((value) => ({
                label: renderBankOption(value),
                value: value,
              }))}
              onChange={handleBankTypeChange}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <FormInputItem
            label="Account Name"
            name="acc_name"
            placeholder="Account Name"
            rules={[{ required: true }]}
            icon={<UserOutlined />}
          />
        </Col>
      </Row>

      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Account No."
            name="acc_number"
            rules={[{ required: true }, { validator: validateAccountNumber }]}
            getValueFromEvent={handleAccNumberChange}
          >
            <Input
              prefix={<FieldNumberOutlined style={{ marginRight: "8px" }} />}
              placeholder="Account Number"
              style={{ width: "100%" }}
              onKeyDown={(e) => {
                const prefix = "+95 ";

                if (
                  selectedBankType.endsWith("PAY") &&
                  ["Backspace", "Delete"].includes(e.key) &&
                  e.target.selectionStart <= prefix.length
                ) {
                  e.preventDefault();
                }

                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24} align="right">
          <Button type="primary" htmlType="submit" loading={loading}>
            Create
          </Button>
          <Button
            onClick={() => closeDrawer(false)}
            style={{ marginLeft: "16px" }}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
